import script from "./NavbarApp.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarApp.vue?vue&type=script&setup=true&lang=js"

import "./NavbarApp.vue?vue&type=style&index=0&id=4d145b8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d145b8a"]])

export default __exports__